/* eslint-disable */
import React, {useEffect, useRef, useState} from "react";
import {Button, Modal, TextField} from "@material-ui/core";
import styles from "./UploadDocument.module.css";
import ShowFileIcon from "./ShowFileIcon";
import {VideoExtraMaterial} from "../../../common/video/models/VideoExtraMaterial";
import {ExtractFileName} from "../../../utils/ObjectUtils";
import PuiMessage from "../../../components/widgets/PuiMessage";
import { useSnackbar } from "notistack";

interface UploadDocumentProps {
    setIsSaved?: (isSaved: boolean) => void;
    alreadyUploadDocumentList: VideoExtraMaterial[];
    ChangeAlreadyUploadDocumentList?: (alreadyUploadDocumentList: VideoExtraMaterial[]) => void;
    ChangeDocumentList: (documentList: any[]) => void;
    documentList: any[];
    ChangeDocumentNameList: (documentNameList: string[]) => void;
    documentNameList: string[];
    ErrorDocumentListLength: (isErrorDocumentListLength: boolean) => void;
}

export default function UploadDocument(
    {setIsSaved, ChangeDocumentList, alreadyUploadDocumentList, ChangeAlreadyUploadDocumentList,
        documentList, ChangeDocumentNameList, documentNameList, ErrorDocumentListLength
   }: UploadDocumentProps) {

    const inputRef = useRef<HTMLInputElement>(null);

    const [uploadDocumentFile, ChangeUploadDocumentFile] = useState(null);
    const [uploadDocumentFileType, ChangeUploadDocumentFileType] = useState("");
    const [uploadDocumentFileName, ChangeUploadDocumentFileName] = useState("");
    const [uploadDocumentName, ChangeUploadDocumentName] = useState("");
    const [limitDocumentNum, LimitDocumentNum] = useState(true);

    const [isErrorInputSize, ChangeErrorInputSize] = useState(false);
    // ファイルサイズエラーバー消去
    const CloseErrorInputBar = () => {
        ChangeErrorInputSize(false);
   };

    // 資料アップロード（資料名入力モーダルopen）
    const UserUploadDocument = (event: any) => {
        console.log("UserUploadDocument start");
        if (event.target.files.length === 1) {
            if(event.target.files[0].size > 0){
                if(event.target.files[0].size >= 1024 * 1024 * 1000){
                    ChangeErrorInputSize(true);
                    if (inputRef.current) {
                        inputRef.current.value = "";
                   }
               }else{
                    ChangeUploadDocumentFile(event.target.files[0]);
                    ChangeUploadDocumentFileType(event.target.files[0].type);
                    ChangeUploadDocumentFileName(event.target.files[0].name);
                    ChangeUploadDocumentName(ExtractFileName(event.target.files[0].name));
                    OpenUploadDocumentModal();
               }
           }else{
                ChangeErrorInputSize(true);
                if (inputRef.current) {
                    inputRef.current.value = "";
               }
           }
       }
   };

    // 資料削除
    // コールバック
    const DeleteFile = (deleteFileIndex: number) => {
        if(alreadyUploadDocumentList){
            if(deleteFileIndex >= alreadyUploadDocumentList.length){
                const deleteUploadFileIndex = deleteFileIndex-alreadyUploadDocumentList.length;
                ChangeDocumentList(documentList.filter((value, index) => index !== deleteUploadFileIndex));
                ChangeDocumentNameList(documentNameList.filter((value, index) => index !== deleteUploadFileIndex));
           }else{
                ChangeAlreadyUploadDocumentList &&
                ChangeAlreadyUploadDocumentList(alreadyUploadDocumentList.filter((value, index) => index !== deleteFileIndex));
           }
       }else{
            ChangeDocumentList(documentList.filter((value, index) => index !== deleteFileIndex));
            ChangeDocumentNameList(documentNameList.filter((value, index) => index !== deleteFileIndex));
       }

        if(setIsSaved){
            setIsSaved(false);
       }
   };

    // 資料アップロードモーダル画面表示制御
    const [isOpenUploadDocumentModal, ShowUploadDocumentModal] = useState(false);
    const [isErrorInputDocumentName, CheckInputDocumentName] = useState(false);

    const OpenUploadDocumentModal = () => {
        ShowUploadDocumentModal(true);
   };

    const CloseUploadDocumentModal = () => {
        ShowUploadDocumentModal(false);
        CheckInputDocumentName(false);
        ChangeUploadDocumentFile(null);
        ChangeUploadDocumentFileType("");
        ChangeUploadDocumentFileName("");
        ChangeUploadDocumentName("");
        if (inputRef.current) {
            inputRef.current.value = "";
       }
   };

    // 資料名入力
    const InputUploadDocumentName = (event: any) => {
        console.log("InputUploadDocumentName start");
        ChangeUploadDocumentName(event.target.value);
   };

    // 資料名入力完了（追加ボタン押下）
    const DoneInputDocumentName = () => {
        console.log("DoneInputDocumentName start");
        if(uploadDocumentName !== ""){
            documentList.push(uploadDocumentFile);
            documentNameList.push(uploadDocumentName);
            CloseUploadDocumentModal();
            if(setIsSaved){
                setIsSaved(false);
           }
       }else{
            CheckInputDocumentName(true);
       }
   };


    useEffect(() => {
        if(alreadyUploadDocumentList){
            if(alreadyUploadDocumentList.length + documentList.length > 5){
                LimitDocumentNum(true);
                ErrorDocumentListLength(true);
           }else{
                LimitDocumentNum(false);
                ErrorDocumentListLength(false);
           }

       }else{
            if(documentList.length > 5){
                LimitDocumentNum(true);
                ErrorDocumentListLength(true);
           }else{
                LimitDocumentNum(false);
                ErrorDocumentListLength(false);
           }
       }
    // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [alreadyUploadDocumentList.length, documentList.length]);

   const { enqueueSnackbar } = useSnackbar()

    return (
        <div>
            <ul className={styles.documentForm}>
                <li className={`${styles.form} ${styles.uploadWrapperBox}`}>
                    <label className={styles.uploadButton} >
                        <input ref={inputRef} id="browserDocumentUploader" multiple type="file" accept="*.pdf"
                            onChange={(e) => {
                                const files = Array.from(e.target.files || []);
                                if (alreadyUploadDocumentList.length  + documentList.length + files.length > 5) {
                                    enqueueSnackbar("ファイルは最大5つまで選択できます。",{
                                        variant: "error",
                                    });
                                    e.target.value = "";
                                    return;
                                }
                                UserUploadDocument(e);
                            }}
                            className={styles.fileDisplay}/>アップロードするファイルを選択（100MBまで）
                    </label>
                    <div className={styles.whiteSpacePreLine}>※ファイルは最大5つまで選択できます。</div>
                </li>

                {/* 資料一覧 */}
                <li className={styles.inputDocumentList} style={{marginBottom: "0"}}>
                    {alreadyUploadDocumentList &&
                        alreadyUploadDocumentList.map((document, index) => (
                            <div className={styles.icon} key={index}>
                                <ShowFileIcon documentIndex={index} fileName={document.fileName} fileType={document.contentType} isVisibleFileName={true} isVisibleDeleteIcon={true} DeleteFile={DeleteFile}/>
                            </div>
                        ))
                   }
                    {documentList &&
                        documentList.map((document, index) => (
                            <div className={styles.icon} key={index}>
                                <ShowFileIcon documentIndex={alreadyUploadDocumentList ? alreadyUploadDocumentList.length + index : index} fileName={document.name} fileType={document.type} isVisibleFileName={true} showfileName={documentNameList[index]} isVisibleDeleteIcon={true} DeleteFile={DeleteFile}/>
                            </div>
                        ))
                   }
                </li>

                {limitDocumentNum &&
                    <li className={styles.checkDocumentNum}>※アップロードできる資料は5つまでです</li>
               }
            </ul>

            {/* 資料確認モーダル */}
            <Modal
                open={isOpenUploadDocumentModal}
                onClose={CloseUploadDocumentModal}
                style={{marginTop: "10vh"}}
            >
                <div className={styles.uploadDocumentModal}>
                    <div style={{marginTop:"40px",marginBottom:"20px"}}>
                        <ShowFileIcon fileName={uploadDocumentFileName}  fileType={uploadDocumentFileType}/>
                    </div>
                    <TextField color="secondary" id="uploadDocumentName" onChange={InputUploadDocumentName} style={{width:"80%"}} autoComplete="off"
                        variant="outlined" placeholder="資料名を入力" defaultValue={ExtractFileName(uploadDocumentFileName)}
                    />
                    <div className={styles.uploadDocumentModalButton}>
                        <Button style={{marginRight:"50px",width:"100px"}} size="small" variant="outlined" type="submit" color="secondary" onClick={CloseUploadDocumentModal}>キャンセル</Button>
                        <Button style={{width:"100px"}} size="small" variant="outlined" type="submit" color="secondary" onClick={DoneInputDocumentName}>追加</Button>
                    </div>
                    <div className={styles.uploadDocumentModalAlart} style={{visibility: isErrorInputDocumentName ? "visible" : "hidden"}}>※資料名を入力してください</div>
                </div>
            </Modal>

            <PuiMessage
                open={isErrorInputSize}
                type="error"
                title="正しいファイルを選択してください(1~100MB)"
                duration={5000}
                onClose={CloseErrorInputBar}
            />

        </div>
    );
}
